<template>
  <div class="about-us-wrapper">
    <div class="journal-top clearfix">
      <div class="jonaral-left">
        <!-- <search></search> -->
      </div>
      <div class="nav-wrapper">
        <span>当前位置：</span>
        <span class="active">版权声明</span>
      </div>
    </div>
    <div class="con-center">
      <item-detail :detail="detail" :detailShow="detailShow"></item-detail>
    </div>
  </div>
</template>
<script>
import search from "@/components/views/common/search.vue";
import itemDetail from "@/components/views/common/itemDetail.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      detailShow: false,
      detail: {}
    };
  },
  mounted() {
    this.conDetail();
  },
  methods: {
    toPage(url) {
      this.$router.push(url);
    },
    conDetail() {
      userApi.statement().then(res => {
        this.detail = res.data;
      });
    }
  },
  components: {
    search,
    itemDetail
  }
};
</script>

<style scoped>
.about-us-wrapper {
  width: 1240px;
  margin: 0 auto;
}
.jonaral-left {
  width: 310px;
  margin-right: 30px;
  float: left;
}
.nav-wrapper {
  font-size: 0;
  margin-bottom: 30px;
}
.nav-wrapper span {
  font-size: 16px;
  color: #212121;
  line-height: 40px;
}
.active {
  color: #194eb0 !important;
  cursor: pointer;
}
.padd {
  padding: 0 4px;
}
.con-center {
  width: 100%;
  border-width: 20px 1px 20px 1px;
  border-color: #e6ecf2;
  border-style: solid;
  border-radius: 10px;
  padding: 50px 199px;
  box-sizing: border-box;
}
</style>




// WEBPACK FOOTER //
// src/components/views/conUs/statement.vue